import React from 'react';
import { NumberString } from '@fourthwall/components';
import { OfferLink } from '../../../components/OfferLink/OfferLink';
import { title } from '../../../consts';
export const mapOffersToAnalyticsRows = (topOfferAnalytics) => {
    if (!topOfferAnalytics)
        return [];
    return topOfferAnalytics.map((offer) => ({
        label: React.createElement(OfferLink, { name: offer.name, label: title, id: offer.offerId, status: offer.status }),
        value: React.createElement(NumberString, { value: offer.unitsSold }),
    }));
};
